import script from "./RoleRequiredByStaff.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleRequiredByStaff.vue?vue&type=script&setup=true&lang=ts"

import "./RoleRequiredByStaff.vue?vue&type=style&index=0&id=6b8dcedf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b8dcedf"]])

export default __exports__